import React from 'react';
import ReactDom from 'react-dom';
import PostCodeInput from './post-code-input';
import DealerInfoSection from './dealer-info-section';
import { isValidPostcode } from '../../../../Shared/Assets/utils';
import EventBus, { EventName } from '../../../../Shared/Assets/event-bus';

export default class DealerAvailabilitySection extends React.Component {
    constructor(props) {
        super(props);

        this.toggleEnquiryForm = this.toggleEnquiryForm.bind(this);

        this.state = {
            postcode: props.postcode
        };

        this.eventBus = new EventBus();
        this.eventBus.handle(EventName.PostCodeChanged, this.postcodeChanged);
    }

    componentDidMount() {
        this.postcodeChanged(this.props.postcode);
    }

    postcodeChanged = (postcode) => {
        if (typeof postcode !== "string" && typeof postcode["postcode"] !== 'undefined') {
            postcode = postcode.postcode;
        }
        this.setState({
            postcode: postcode
        }, () => {
            if (isValidPostcode(this.state.postcode)) {
                this.props.formElement.Postcode.value = this.state.postcode;
            } else {
                this.props.formElement.Postcode.value = "";
                this.toggleEnquiryForm(false);

                // display default price on detail
                this.eventBus.dispatch(EventName.PostCodeChanged, { postcode: "" });
            }
        });
    }

    toggleEnquiryForm(isEnabled) {
        this.props.formElement.getElementsByTagName("fieldset")[0].disabled = !isEnabled;
        this.props.formElement.btnSubmitEnquiry.disabled = !isEnabled;
    }

    render() {
        const sectionClassName = "dealer-availability-section " + this.props.placement;
        const dealerInfoData = {
            postcode: this.state.postcode,
            placement: this.props.placement,
            toggleEnquiryForm: this.toggleEnquiryForm
        };
        if (this.props.hasDealerAvailability) {
            dealerInfoData.dealerApiUrl = this.props.dealerApiUrl;
        }
        return (
            <div className={sectionClassName}>
                <DealerInfoSection {...dealerInfoData} />
            </div>
        );
    }
}